import {minWidthMedia} from "@irati/ui/src/global/media"

import styled from "styled-components"

const Image = styled.img`
  background-color: ${({theme}) => theme.colors.greys.white};
  border-radius: 5px;
  box-shadow: 0 0 3px 0 rgba(61, 61, 54, 0.2), 0 3px 2px 2px rgba(61, 61, 54, 0.15);
  height: 60px;
  max-width: none;
  width: 60px;
  ${(props) => (props.leftMargin ? "margin-left: 15px;" : "")}

  ${minWidthMedia.tablet`
    height: 90px;
    width: 90px;
  `}
`

export default Image
